import { summaryProgramType } from 'legacy/lut/features/partner360/configuration/constants'
import { parseProgramOfferings } from 'legacy/lut/services/partner360/configuration/helpers/parseProgramOfferings'
import { mapPartner360ProgramTypes } from 'legacy/lut/services/partner360/configuration/mappings/mapPartner360ProgramTypes'

import type { I621Form } from '../api/types'
import type { ICockpitPartnerOfferingsCatalog } from '../model/types'

export const getPartnerOfferingsCatalog = (
  partnerData: I621Form[]
): ICockpitPartnerOfferingsCatalog[] =>
  partnerData.map((partner) => {
    const allOfferings = parseProgramOfferings(partner.AllProgramOfferingsJson)
    const enabledOfferings = partner.ProgramOfferings?.split(',').filter(Boolean) ?? []

    return {
      partnerId: partner.PartnerId.trim(),
      offerings: [...mapPartner360ProgramTypes(allOfferings, enabledOfferings), summaryProgramType],
    }
  })
